export default __webpack_public_path__ + "static/media/groupSubscriptions.fb18ec95.PNG";